// extracted by mini-css-extract-plugin
module.exports = {"authForm":"AuthForm_authForm__3tebI"};